import { Modal, Text } from '@querodelivery/uni-react';
import type { MissionCity } from '../../types';
import styles from './mission-cities-modal.module.scss';

interface MissionCitiesModalProps {
  isOpen: boolean;
  cities: MissionCity[];
  onClose: () => void;
}

export const MissionCitiesModal = ({
  isOpen,
  cities,
  onClose,
}: MissionCitiesModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="480px"
      header="Municípios da missão"
    >
      <div className={styles.content}>
        <Text variant="bodyXs" tone="supporting" fontWeight="medium">
          {cities.length} municípios participantes
        </Text>
        <ul className={styles.list}>
          {cities.map(city => (
            <li key={city._id} className={styles.item}>
              <Text variant="bodySm" tone="base" fontWeight="medium">
                {city.name} - {city.uf}
              </Text>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};
